<template>
  <section
    class="contact-city-section component component--uniform"
    :style="{ backgroundImage: desktopImageStyle }"
  >
    <div class="container" :style="{ backgroundImage: mobileImageStyle }">
      <h2>
        {{ data.title }}
      </h2>

      <div v-html="data.text" />

      <div v-if="phoneNumber" class="hide-on-mobile">
        <p
          @click="gtmPhoneCallTrigger($event, 'City page - Contact Section')"
          v-html="callUsString"
        />
      </div>

      <div class="buttons">
        <a
          v-for="(link, i) in data.links"
          :key="i"
          :href="link.link.url"
          class="btn n-btn icon-right"
          :target="link.link.target"
        >
          {{ link.link.title }}
          <svg class="icon"><use href="#arrow-right-long" /></svg>
        </a>
        <button
          v-if="data.contact_form_button_text"
          class="js-toggle-global-contact-form btn n-btn icon-right"
          data-location="contact-city-section"
        >
          {{ data.contact_form_button_text }}
          <svg class="icon"><use href="#arrow-right-long" /></svg>
        </button>
      </div>

      <button
        class="mobile-buttons-toggler btn n-btn small"
        @click="is_active ^= true"
      >
        <svg v-if="is_active" class="icon">
          <use href="#plus" />
        </svg>

        <svg v-else class="icon">
          <use href="#minus" />
        </svg>
      </button>
    </div>

    <div class="container mobile-buttons" :class="{ hidden: !is_active }">
      <a :href="phoneNumberTel" class="btn n-btn icon-right">
        {{ data.mobile_top_link_text }} {{ phoneNumber }}
        <svg class="icon"><use href="#arrow-right-long" /></svg>
      </a>
      <a
        v-for="(link, i) in data.links"
        :key="i"
        :href="link.link.url"
        class="btn n-btn icon-right"
      >
        {{ link.link.title }}
        <svg class="icon"><use href="#arrow-right-long" /></svg>
      </a>
      <button
        v-if="data.contact_form_button_text"
        class="js-toggle-global-contact-form btn n-btn icon-right"
        data-location="contact-city-section"
      >
        {{ data.contact_form_button_text }}
        <svg class="icon"><use href="#arrow-right-long" /></svg>
      </button>
    </div>
  </section>
</template>

<script>
import { usePhoneNumber } from 'Main/composables/usePhoneNumber';
import { sprintf } from 'sprintf-js';

export default {
  name: 'ContactCitySection',

  setup() {
    const {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    } = usePhoneNumber();
    return {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    };
  },

  data() {
    const localData = JSON.parse(this.$mountEl.dataset.localData);
    const globalData = JSON.parse(this.$mountEl.dataset.globalData);
    let data = {};

    if (localData) {
      data = Object.keys(localData)
        .filter((k) => localData[k])
        .reduce((a, k) => ({ ...a, [k]: localData[k] }), {});
      data = Object.assign(globalData, data);
    } else {
      data = globalData;
    }

    return {
      texts: theme_vars.contactCitySection,
      is_active: true,
      windowWidth: window.innerWidth,
      data,
    };
  },

  computed: {
    callUsString() {
      if (!this.phoneNumber) {
        return '';
      }

      const { callUs } = this.texts;
      return sprintf(callUs, this.phoneNumberTel, this.phoneNumber);
    },

    mobileImageStyle() {
      if (!this.data?.mobile_image || this.windowWidth > 991) {
        return 'none';
      }

      return `url( ${this.data.mobile_image} )`;
    },

    desktopImageStyle() {
      if (!this.data?.desktop_image || this.windowWidth <= 991) {
        return 'none';
      }

      return `url( ${this.data.desktop_image} )`;
    },
  },

  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },
};
</script>
